!((document, Drupal, $) => {
  'use strict';

  /**
   * Use this to describe what your behavior does.
   */
  Drupal.behaviors.whatIsInBloom = {
    attach: function() {
      const $cardsWithoutCta = $('.what-is-in-bloom .card--without-cta');
      const $cardsWithCta = $('.what-is-in-bloom .card--with-cta');
      const $firstCard = $cardsWithoutCta.first();
      const $lastCard = $cardsWithoutCta.last();
      const $numOfCards = $cardsWithoutCta.length;

      /**
       * Styles the component accdg to the number of cards (for with CTA)
       * @constructor
       * @param {number} number - Number of image cards.
       */
      function styleWithCta(number) {
        switch (number) {
          case 7:
            $($cardsWithoutCta[2]).addClass('cta-card');
            break;
          case 6:
            $($cardsWithoutCta[2]).addClass('cta-card');
            $firstCard.css({ 'grid-row': '1 / span 4' });
            break;
          case 5:
            $($cardsWithoutCta[2]).addClass('cta-card');
            $firstCard.css({ 'grid-row': '1 / span 4' });
            $($cardsWithoutCta[1]).css({ 'grid-row': '1 / span 4' });
            break;
          case 4:
            $($cardsWithoutCta[2]).addClass('cta-card');
            $firstCard.css({ 'grid-row': '1 / span 4' });
            $lastCard.css({ 'grid-row': '1 / span 4' });
            $($cardsWithoutCta[1]).css({ 'grid-row': '1 / span 4' });
            break;
          case 3:
            $firstCard.css({ 'grid-row': '1 / span 4' });
            $($cardsWithoutCta[1]).css({ 'grid-row': '1 / span 4' });
            $lastCard.css({
              'grid-column': '5 / span 4',
              'grid-row': '1 / span 2'
            });
            $lastCard.addClass('cta-card');
            $cardsWithCta.css({ 'grid-column': '5 / span 4' });
            break;
          case 2:
            $firstCard.css({
              'grid-row': '1 / span 4',
              'grid-column': '1 / span 4'
            });
            $lastCard.css({
              'grid-column': '5 / span 4',
              'grid-row': '1 / span 2'
            });
            $lastCard.addClass('cta-card');
            $cardsWithCta.css({ 'grid-column': '5 / span 4' });
            break;
          case 1:
            $firstCard.css({
              'grid-row': '1 / span 2',
              'grid-column': '1 / span 8'
            });
            $cardsWithCta.css({
              'grid-row': '3 / span 2',
              'grid-column': '1 / span 8'
            });
            $firstCard.addClass('cta-card');
            break;
        }
      }

      /**
       * Styles the component accdg to the number of cards (for without CTA)
       * @constructor
       * @param {number} number - Number of image cards.
       */
      function styleWithoutCta(number) {
        switch (number) {
          case 7:
            $firstCard.css({ 'grid-row': '1 / span 4' });
            $($cardsWithoutCta[5]).css({ 'grid-row': '3 / span 2' });
            break;
          case 6:
            $firstCard.css({ 'grid-row': '1 / span 4' });
            $lastCard.css({ 'grid-row': '1 / span 4' });
            $($cardsWithoutCta[3]).css({ 'grid-row': '3 / span 2' });
            $($cardsWithoutCta[4]).css({ 'grid-row': '1 / span 2' });
            break;
          case 5:
            $firstCard.css({ 'grid-row': '1 / span 4' });
            $lastCard.css({ 'grid-row': '1 / span 4' });
            $($cardsWithoutCta[3]).css({
              'grid-row': '3 / span 2',
              'grid-column': '3 / span 4'
            });
            break;
          case 4:
            $firstCard.css({ 'grid-row': '1 / span 4' });
            $lastCard.css({ 'grid-row': '1 / span 4' });
            $($cardsWithoutCta[1]).css({ 'grid-row': '1 / span 4' });
            $($cardsWithoutCta[2]).css({ 'grid-row': '1 / span 4' });
            break;
          case 3:
            $firstCard.css({ 'grid-row': '1 / span 4' });
            $lastCard.css({ 'grid-row': '1 / span 4' });
            $($cardsWithoutCta[1]).css({
              'grid-row': '1 / span 4',
              'grid-column': '3 / span 4'
            });
            break;
          case 2:
            $firstCard.css({
              'grid-row': '1 / span 4',
              'grid-column': '1 / span 4'
            });
            $lastCard.css({
              'grid-row': '1 / span 4',
              'grid-column': '5 / span 4'
            });
            break;
          case 1:
            $firstCard.css({
              'grid-row': '1 / span 4',
              'grid-column': '1 / span 8'
            });
            break;
        }
      }

      if ($firstCard && $lastCard) {
        $firstCard.addClass('first-card');
        $lastCard.addClass('last-card');
      }

      if ($numOfCards > 7) {
        $($cardsWithoutCta[2]).addClass('cta-card');
      }

      if ($cardsWithCta.length > 0) {
        styleWithCta($numOfCards);
      }
      else {
        styleWithoutCta($numOfCards);
      }
    }
  };
})(document, Drupal, jQuery);
